module.exports = __webpack_public_path__ + "static/img/bca.beec3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/partners/bca.png
// module id = P5Za
// module chunks = 1